import { formatDistance } from "./km/_lib/formatDistance.js";
import { formatLong } from "./km/_lib/formatLong.js";
import { formatRelative } from "./km/_lib/formatRelative.js";
import { localize } from "./km/_lib/localize.js";
import { match } from "./km/_lib/match.js";

/**
 * @category Locales
 * @summary Khmer locale (Cambodian).
 * @language Khmer
 * @iso-639-2 khm
 * @author Seanghay Yath [@seanghay](https://github.com/seanghay)
 */
export const km = {
  code: "km",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
};

// Fallback for modularized imports:
export default km;
